<script>
  export let category = 'sports';
  export let items = [];
</script>

<div class="menu">
  <div class="left">
    {#each items as item}
      <a href={category + '/' + item.slug} target="_self" class="link">{item.name}</a>
    {/each}
  </div>
</div>

<style>
  .menu {
    background-color: #1c2a5c;
    width: 25rem;
    top: 0;
    left: 0;
    position: absolute;
    display: grid;
    grid-template-columns: 1fr;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    z-index: 11;
    height: auto;
  }

  .left {
    padding: 2rem;
  }

  .link {
    display: block;
    padding: 1rem 0;
    color: #fff;
    text-decoration: none;
  }

  .link:hover {
    color: #fff;
    text-decoration: underline;
  }
</style>
